import React from 'react';

type Props = {
  countryCode: string;
  size?: number;
  className?: string;
};

// Map of country codes to flag image URLs
const getFlagUrl = (countryCode: string): string => {
  // Using flag CDN that provides SVG flags by country code
  return `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
};

export const Flag = ({ countryCode, size = 24, className = '' }: Props) => {
  // Get country name for accessibility
  const getCountryName = (code: string): string => {
   const countries: Record<string, string> = {
  'CH': 'Switzerland',
  'FR': 'France',
  'IT': 'Italy',
  'CA': 'Canada',
  'ES': 'Spain',
  'CN': 'China',
  'GB': 'UK',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'US': 'USA',
  'DE': 'Germany',
  'SE': 'Sweden',
  'NZ': 'New Zealand'
};

    return countries[code] || code;
  };

  if (!countryCode) return null;
  
  return (
    <img
      src={getFlagUrl(countryCode)}
      alt={`Flag of ${getCountryName(countryCode)}`}
      className={`inline-block object-cover ${className}`}
      style={{ 
        width: size, 
        height: size,
        borderRadius: 2,
        verticalAlign: 'middle',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
      }}
    />
  );
};